import React from "react";

function PaymentComponent() {
  return (
    <div className="py-[29px] px-[40px] border custom-border rounded-[20px] max-w-md mx-auto">
      <h2 className="text-xl font-semibold">Deposit</h2>
      <p className="mb-4 mt-3">
        Please fill out the form below to deposit to a server:
      </p>
      <ol className="list-decimal list-inside mb-4">
        <li>Select a server provider from the dropdown.</li>
        <li>Enter your username and email for the server provider</li>
        <li>Enter the amount you would like to load.</li>
      </ol>

      <div className="mb-4 payment-inputs">
        <label htmlFor="paymentMethod" className="block mb-1">
          Payment Method:
        </label>
        <input
          type="text"
          id="paymentMethod"
          placeholder="Enter payment method"
          className="w-full p-2 border custom-border rounded outline-none"
        />
      </div>

      <div className="mb-4 payment-inputs">
        <label htmlFor="amount" className="block mb-1">
          Amount:
        </label>
        <input
          type="number"
          id="amount"
          placeholder="Enter amount"
          className="w-full p-2 border custom-border rounded outline-none"
        />
      </div>
      <div className="payment-btn  py-2">
        <button
          className="box-shadow px-6 py-1 bg-gradient-to-b from-yellow-400 to-yellow-600 text-black font-bold rounded-md shadow-md 
         border-yellow-700 hover:brightness-110 transition"
        >
          <a
            className="text-black font-bold"
            href="/dashboard"
            data-discover="true"
          >
            Proceed
          </a>
        </button>
      </div>
    </div>
  );
}

export default PaymentComponent;
